// src/services/clientsAPI.js

import api from '../api/api'; // adapte le chemin si besoin

const BASE_URL = '/clients';

function findAll() {
  return api
    .get(BASE_URL)
    .then(response =>
      response.data.map(client => ({
        id: client._id,                 // normalisation pour le frontend
        nom: client.contactName,        // contactName utilisé comme nom
        prenom: client.companyName || '', // companyName comme prénom ou vide
        forfait: client.forfait || 0,
        ...client
      }))
    );
}

function find(id) {
  return api
    .get(`${BASE_URL}/${id}`)
    .then(response => ({
      id: response.data._id,
      nom: response.data.contactName,
      prenom: response.data.companyName || '',
      forfait: response.data.forfait || 0,
      ...response.data
    }));
}

function create(client) {
  return api.post(BASE_URL, client);
}

function update(id, client) {
  return api.put(`${BASE_URL}/${id}`, client);
}

function deleteClient(id) {
  return api.delete(`${BASE_URL}/${id}`);
}

export default {
  findAll,
  find,
  create,
  update,
  delete: deleteClient
};
